import { Injectable } from '@angular/core';
import {Headers, Http, RequestMethod, RequestOptions, Response} from '@angular/http';
import {Router} from '@angular/router';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ImportSettingsService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
  }

  public getAllRulesImports() {

    return this._http.get(
      constant.URL_IMPORT_TYPE, this.getHeader()
    ).map(resp => resp.json());
  }

  public setRuleImport(body) {
    return this._http.put(
      constant.URL_IMPORT_TYPE, body, this.headerPost()
    ).map(resp => resp.json(), error => error.json());
  }

  public insertImport(body) {
    return this._http.post(
      constant.URL_IMPORT_TYPE, body, this.headerPost()
    ).map(res => res.json(), error => error.json());
  }

  public createTemplateImport(data: any) {
    const dataString = JSON.stringify(data);
    return this._http.post(constant.URL_IMPORT_TEMPLATE, dataString, this.headerPost())
      .map(res => res.json(), error => error.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public updateTemplateImport(data: any, id: number) {
    const dataString = JSON.stringify(data);
    return this._http.put(constant.URL_IMPORT_TEMPLATE, `${ dataString}/${id}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/import-settings/import-settings.service.ts